import React, { createContext, FC, useContext, useMemo } from "react"

import useMedia from "use-media"

import { MOBILE_MAX_WIDTH, TABLET_MAX_WIDTH } from "../lib/ts/clientInfo"

type Props = {
	children: React.ReactNode
}

type Context = {
	isMobile: boolean
	isIPad: boolean
}

const MediaQueryContext = createContext<Context>({
	isMobile: false,
	isIPad: false,
})

// breakpoint は fe_event の device_type と同じ値を使う (lib/ts/clientInfo.ts が定義元)
const mediaQueries = {
	mobile: `(max-width: ${MOBILE_MAX_WIDTH}px)`,
	iPad: `(min-width: ${MOBILE_MAX_WIDTH + 1}px) and (max-width: ${TABLET_MAX_WIDTH}px)`,
}

export const MediaQueryProvider: FC<Props> = ({ children }: Props) => {
	const isMobile = useMedia(mediaQueries.mobile)
	const isIPad = useMedia(mediaQueries.iPad)
	const value = useMemo(() => ({ isMobile, isIPad }), [isMobile, isIPad])

	return (
		<MediaQueryContext.Provider value={value}>
			{children}
		</MediaQueryContext.Provider>
	)
}

export const useMediaQueryContext = (): Context => useContext(MediaQueryContext)
